import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import Container from '../components/Container';
import Card from '../components/Card';
import PageHeader from '../components/PageHeader';

const { REACT_APP_API_ROOT = 'v2.api.bible' } = process.env;

export default function ApiReference() {
  const swaggerUrl = `https://${REACT_APP_API_ROOT}/swagger.json`;

  // TODO: Use requestInterceptor to prepopulate api key

  return (
    <Container>
      <PageHeader
        title="API Reference"
        note="Use our live API reference to learn about API.Bible and try it out by enterning your application's API key."
      />
      <Card className="relative px-6 pt-0 overflow-x-auto md:px-10">
        <SwaggerUI url={swaggerUrl} />
      </Card>
    </Container>
  );
}
